import { navigate } from 'gatsby';
import { useQueryClient } from 'react-query';
import { clearAuthHeader } from 'lib/util/graphqlFetcher';
import { useAuthStore, useRegistrationStore } from '../store';

export interface LoginOptions {
  redirectPath?: string;
}

export const useLogin = () => {
  const { setToken } = useAuthStore();

  return (token: string, options?: LoginOptions) => {
    const { redirectPath } = options;

    if (!token) return console.error('Must provide an auth token');

    setToken(token);
    navigate(redirectPath || `/account`);
  };
};

export const useClearUserState = () => {
  const queryClient = useQueryClient();
  const { reset } = useRegistrationStore();
  const { clearToken } = useAuthStore();

  return () => {
    reset();
    clearToken();

    // NOTE: We need to clear the auth header to to prevent bugs where
    // our user remains "logged in" unless the user refreshes the page.
    clearAuthHeader();

    // NOTE: Since we are persisting the React Query data, we need to manually clear the cache.
    queryClient.clear();
  };
};

export const useLogout = () => {
  const clearState = useClearUserState();

  return () => {
    clearState();
    navigate('/login');
  };
};
